import { index, pgTable, uuid, varchar } from 'drizzle-orm/pg-core';
import {
  defaultFields,
  defaultHistoryFields,
} from '@trashlab/api/drizzle/default';

export const customer_segment = pgTable(
  'customer_segment',
  {
    ...defaultFields.fieldsWithTenantId(),
    lastModifiedBy: uuid('lastModifiedBy'),
    createdBy: uuid('createdBy'),
    legacySystemId: varchar('legacySystemId', { length: 255 }),
    name: varchar('name', { length: 255 }).notNull(),
  },
  (table) => {
    return {
      createdAtTs_idx: index('customer_segment_createdAtTs_idx').on(
        table.createdAtTs,
      ),
      tenantId_idx: index('customer_segment_tenantId_idx').on(table.tenantId),
      updatedAtTs_idx: index('customer_segment_updatedAtTs_idx').on(
        table.updatedAtTs,
      ),
      updatedAtTs_idx1: index('customer_segment_updatedAtTs_idx1').on(
        table.updatedAtTs.desc(),
      ),
      versionNumber_idx: index('customer_segment_versionNumber_idx').on(
        table.versionNumber,
      ),
    };
  },
);

export const customer_segment_history = pgTable('customer_segment_history', {
  ...defaultHistoryFields.historyFieldsWithTenantId(),
  lastModifiedBy: uuid('lastModifiedBy'),
  createdBy: uuid('createdBy'),
  legacySystemId: varchar('legacySystemId', { length: 255 }),
  name: varchar('name', { length: 255 }),
});
